module.exports = __webpack_public_path__ + "static/google_store@2x.494c736b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/google_store@2x.jpg
// module id = 660
// module chunks = 193162123475590